import { useEffect } from 'react';

/**
 * The id of the stylesheet `scripts/og/injectBody.js` adds to a prerendered
 * document. Duplicated as a literal on purpose — this file is compiled into the
 * browser bundle and that one runs in a build script, so there is no import
 * either could make. src/prerender/__tests__/prerenderStyleLifecycle.test.ts
 * reads both files and fails if the two strings drift apart.
 */
export const PRERENDER_STYLE_ID = 'thea-prerender-style';

/**
 * Removes the prerendered stylesheet once React has committed.
 *
 * WHY IT HAS TO GO. `/`, `/privacy` and `/terms` ship with their body already
 * rendered inside `#root`, and with the styled-components CSS for that markup
 * inlined in `<head>`. The class names in it were invented by a Node build of
 * the components, whose module evaluation order is not the browser bundle's —
 * styled-components derives generated names from a counter, so the same name
 * (`.sc-aXZVg`) means one component here and a different one there.
 *
 * React clears `#root` on its first commit, so from that moment the markup
 * those rules were written for no longer exists and every rule in the tag is
 * either dead or, on a collision, actively wrong: a live element inheriting
 * `min-height: 100vh` from a prerendered wrapper's rule. Deleting the tag at
 * the commit that orphans it closes the window entirely — there is never a
 * moment when both the stale sheet and the live tree are in the document.
 *
 * Mounting this as a component rather than calling `.remove()` after
 * `root.render()` is the difference between "after the DOM was replaced" and
 * "after render was scheduled": `createRoot().render()` is concurrent and does
 * not commit synchronously, so a bare call beside it can run while the
 * prerendered markup is still on screen — unstyling the page for a frame,
 * which is the exact flash this whole feature exists to avoid.
 */
export function PrerenderStyleCleanup(): null {
  useEffect(() => {
    document.getElementById(PRERENDER_STYLE_ID)?.remove();
  }, []);
  return null;
}
